import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    const billingCode = err.response?.data?.code;

    if (err.response?.status === 402 && ['TRIAL_EXPIRED', 'SUBSCRIPTION_REQUIRED'].includes(billingCode)) {
      try {
        const stored = JSON.parse(localStorage.getItem('user') || '{}');
        const updated = {
          ...stored,
          plan: err.response?.data?.plan || stored.plan,
          subscriptionStatus: err.response?.data?.subscriptionStatus || 'expired',
          subscriptionEndDate: err.response?.data?.subscriptionEndDate || null,
        };
        localStorage.setItem('user', JSON.stringify(updated));
      } catch {
        // ignore local storage parse issues
      }

      if (!window.location.pathname.startsWith('/pricing') && !window.location.pathname.startsWith('/payment/verify')) {
        window.location.href = '/pricing?billing=required';
      }
      return Promise.reject(err);
    }

    // If 401 and we haven't already retried this request
    if (err.response?.status === 401 && !original._retry) {
      original._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) throw new Error('No refresh token');

        const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
        const res = await axios.post(`${baseURL}/auth/refresh`, { refreshToken });

        const { token: newToken, refreshToken: newRefreshToken, user } = res.data;
        localStorage.setItem('token', newToken);
        localStorage.setItem('refreshToken', newRefreshToken);
        if (user) localStorage.setItem('user', JSON.stringify(user));

        // Retry original request with new token
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      } catch {
        // Refresh failed — clear session and redirect
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(err);
      }
    }

    return Promise.reject(err);
  }
);

export default api;
